export default {
    input: (h, params, prop = {}) => {
        const attr = prop.attr || params.column.key;
        const tableData = prop.tableData || [];
        const clearable = prop.clearable === undefined ? true : prop.clearable;
        const disabled = prop.disabled === undefined ? false : (typeof prop.disabled === 'function' ? prop.disabled() : prop.disabled);
        const readonly = prop.readonly === undefined ? false : (typeof prop.readonly === 'function' ? prop.readonly() : prop.readonly);
        const size = prop.size || 'small';
        const icon = prop.icon || '';
        const { isObvious } = prop;
        return h('Input', {
            props: {
                value: params.row[attr],
                size,
                readonly,
                clearable,
                disabled,
                icon,
            },
            style: {
                border: isObvious ? '1px red solid' : '',
            },
            on: {
                'on-change': (event) => {
                    params.row[attr] = event.target.value;
                    tableData[params.index] = params.row;
                    prop.change && prop.change(event.target.value);
                },
                'on-focus': () => {
                    prop.focus && prop.focus();
                },
                'on-blur': (event) => {
                    prop.blur && prop.blur(event.target.value);
                },
            },
        });
    },
    inputNumber: (h, params, prop = {}) => {
        const attr = prop.attr || params.column.key;
        const tableData = prop.tableData || [];
        const disabled = prop.disabled === undefined ? false : (typeof prop.disabled === 'function' ? prop.disabled() : prop.disabled);
        const readonly = prop.readonly === undefined ? false : (typeof prop.readonly === 'function' ? prop.readonly() : prop.readonly);
        const size = prop.size || 'small';
        const min = prop.min === undefined ? -Infinity : prop.min;
        const max = prop.max === undefined ? Infinity : prop.max;
        const editable = prop.editable === undefined ? true : prop.editable;
        const width = prop.width === undefined ? 100 : prop.width;
        // let precision = prop.precision === undefined ? false : prop.editable;
        const { isObvious } = prop;
        return h('InputNumber', {
            props: {
                value: params.row[attr],
                size,
                readonly,
                disabled,
                min,
                max,
                editable,
            },
            style: {
                width: `${width}px`,
                border: isObvious ? '1px red solid' : '',
            },
            on: {
                'on-change': (val) => {
                    params.row[attr] = val;
                    tableData[params.index] = params.row;
                    prop.change && prop.change(event.target.value);
                },
                'on-focus': () => {
                    prop.focus && prop.focus();
                },
                'on-blur': () => {
                    prop.blur && prop.blur();
                },
            },
        });
    },
    select: (h, params, prop = {}) => {
        const attr = prop.attr || params.column.key;
        const { attrLabel } = prop;
        const tableData = prop.tableData || [];
        const options = (typeof prop.options === 'function' ? prop.options() : prop.options) || [];
        const clearable = prop.clearable === undefined ? true : prop.clearable;
        const filterable = prop.filterable === undefined ? true : prop.filterable;
        const disabled = prop.disabled === undefined ? false : (typeof prop.disabled === 'function' ? prop.disabled() : prop.disabled);
        const size = prop.size || 'small';
        const transfer = prop.transfer === undefined ? false : prop.transfer;
        const multiple = prop.multiple === undefined ? false : prop.multiple;
        const { isObvious } = prop;
        return h('Select', {
            props: {
                value: params.row[attr],
                size,
                clearable,
                filterable,
                disabled,
                transfer,
                multiple,
            },
            style: {
                border: isObvious ? '1px red solid' : '',
            },
            on: {
                'on-change': (val) => {
                    params.row[attr] = val;
                    if (attrLabel) {
                        const { label } = options.find(item => {
                            return item.value === val;
                        }) || {};
                        params.row[attrLabel] = label;
                    }
                    tableData[params.index] = params.row;
                    prop.change && prop.change(val);
                },
            },
        }, options.map((type) => {
            return h('Option', {
                props: {
                    value: type.value,
                    label: type.label,
                },
            });
        }));
    },
    datePicker: (h, params, prop = {}) => {
        const attr = prop.attr || params.column.key;
        const tableData = prop.tableData || [];
        const clearable = prop.clearable === undefined ? true : prop.clearable;
        const disabled = prop.disabled === undefined ? false : (typeof prop.disabled === 'function' ? prop.disabled() : prop.disabled);
        const size = prop.size || 'small';
        const dateType = prop.dateType || 'date';
        const format = prop.format || 'yyyy-MM-dd';
        const options = prop.options || null;
        const style = prop.style === undefined ? {} : prop.style;
        return h('DatePicker', {
            props: {
                value: params.row[attr],
                type: dateType,
                format,
                size,
                clearable,
                disabled,
                options,
            },
            style,
            on: {
                'on-change': (val) => {
                    params.row[attr] = val;
                    tableData[params.index] = params.row;
                    prop.change && prop.change(val);
                },
                'on-clear': () => {
                    params.row[attr] = '';
                    tableData[params.index] = params.row;
                    prop.clear && prop.clear();
                },
            },
        });
    },
    button: (h, params, prop = {}) => {
        const type = prop.type || 'text';
        const { icon } = prop;
        const disabled = prop.disabled === undefined ? false : (typeof prop.disabled === 'function' ? prop.disabled() : prop.disabled);
        const size = prop.size || 'small';
        const text = prop.text || '';
        const loading = prop.loading || false;
        const style = prop.style || { padding: 0 };
        return h('Button', {
            style,
            props: {
                type,
                icon,
                disabled,
                size,
                loading,
            },
            on: {
                click: () => {
                    prop.click && prop.click();
                },
            },
        }, text);
    },
    a: (h, params, prop = {}) => {
        const attr = prop.attr || params.column.key;
        const href = prop.href || '';
        return h('a', {
            attrs: {
                href,
            },
        }, params.row[attr]);
    },
    link: (h, params, prop = {}) => {
        const attr = prop.attr || params.column.key;
        return h('span', {
            style: {
                cursor: 'pointer',
                color: '#0077FF',
            },
            on: {
                click: () => {
                    prop.click && prop.click();
                },
            },
        }, params.row[attr] || prop.text);
    },
    upload: (h, params, prop = {}) => {
        const style = prop.style || {
            fontSize: '19px',
        };
        const action = prop.action || '';
        const data = prop.data || {};
        const loading = prop.loading || false;
        return h('Upload',
            {
                props: {
                    action,
                    showUploadList: false,
                    data,
                    beforeUpload: (file) => {
                        return prop.beforeUpload && prop.beforeUpload(file);
                    },
                    onProgress: () => {
                        prop.onProgress && prop.onProgress();
                    },
                    onSuccess: (response, file) => {
                        prop.onSuccess && prop.onSuccess(response, file);
                    },
                },
                style,
            },
            [
                h('Button', {
                    props: {
                        type: 'text',
                        icon: 'upload',
                        loading,
                    },
                    style: {
                        fontSize: '19px',
                        padding: 0,
                    },
                }),
            ]);
    },
    buttons: (h, params, options = []) => {
        options = (options || []).filter(item => (item.show === undefined ? true : item.show));
        return h('div', {}, options.map(item => {
            const type = item.type || 'text';
            const icon = item.icon || '';
            const disabled = item.disabled === undefined ? false : (typeof item.disabled === 'function' ? item.disabled() : item.disabled);
            const size = item.size || 'small';
            const text = item.text || '';
            const style = item.style || { padding: '0 5px' };
            return h('Button', {
                props: {
                    type,
                    icon,
                    disabled,
                    size,
                },
                style,
                on: {
                    click: () => {
                        item.click && item.click();
                    },
                },
            }, text);
        }));
    },
    span: (h, params) => {
        return h('div', [
            h('span', { style: { color: 'red' } }, '* '),
            h('span', {}, params.column.title),
        ]);
    },
    viewFile: (h, fileName, docId, slot = '') => {
        if (!docId) return '';
        // 文件名
        const file = h('span', {
            style: {
                cursor: 'pointer',
                color: '#0077FF',
            },
            on: {
                click: () => {
                    // openFile({ fileName, docId })
                },
            },
        }, fileName);
        // 下载图标
        const icon = h('span', {
            domProps: {
                innerHTML: '<i class="m-icon m-icon-ios-download-outline"></i>',
            },
            style: {
                fontSize: '18px',
                padding: '0px 2px 0 15px',
                cursor: 'pointer',
            },
            on: {
                click: () => {
                    const link = document.createElement('a');
                    link.setAttribute('href', `/srmbase/commonFile/downloadFileByDocId?docId=${docId}`);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                },
            },
        });
        const tooltip = h('Tooltip', {
            props: {
                content: '下载文件',
                placement: 'top',
            },
            style: {
                overflow: 'initial',
            },
        }, [icon]);
        return h('div', {
            style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            },
        }, [file, tooltip, slot]);
    },
};
